import {
  Box,
  Stack,
  Typography,
  Chip,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  InputLabel,
} from "@mui/material";
import CustomDatagrid from "./CustomDatagrid";
import { getGlobals } from "../../../Configs";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { CmpDatePickerField001V1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import { useSelector } from "react-redux";
import { fAlertToast } from "../../../Utility/Utilitys";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import PromotionCreationSidenav from "../Initialization/PromotionSidenav";
import DesignDrawer from "../Design/DesignDrawer";
import DeleteIcon from "@mui/icons-material/Delete";
import { PAP_Head_Userwise_DeleteApi } from "../../../Server/ApiV2";
import { confirmAlert } from "react-confirm-alert";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import SendPrintingSideNav from "../SendToPrinting/SendPrintingSideNav";
import CategorySelectionSideNav from "../CategorySelection/CategorySelectionDetail";
import ActivityModal from "./Activity";
import {
  PackingUnit_Buyer_getrowsAPI,
  QuickSale_PAP_Head_Summary,
} from "../../../Server/ApiV2";

import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import ItemSelectionSideNav from "../ItemSelctionAndVerification/ItemSelectionSideNav";
import ReceivedFromPrintingSideNav from "../Received/ReceivedFromPrintingSideNav";
import AnalysisReport from "../AnalysisReport/AnalysisReport";

const statusOptions = ["All", "Enter", "Post"];
const PromoStatus = ["ALL","Planning","In-Progress","Completed"];

export default function PromotionAutomationSummary() {
  const queryParams = useLocation();
  const showPagination = false;
  const pageType = queryParams.search.split("typ=")[1];
  const baseURL = getGlobals().API_BASE_URL;
  const locationArr = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const vRdxUserCd = useSelector((state) => state.login.value);
  // -------- state
  const [rows, setRows] = useState([]);
  const [promoCreationDrawer, setPromoCreationDrawer] = useState(false);
  const [categoryDrawer, setCategoryDrawer] = useState(false);
  const [itemSelectionDrawer, setItemSelectionDrawer] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState({});
  const [sendDrawer, setSendDrawer] = useState(false);
  const [designDrawer, setDesignDrawer] = useState(false);
  const [receivedDrawer, setReceivedDrawer] = useState(false);
  const [analysis, setAnalysis] = useState(false);
  const [bookletSizes, setBookletSizes] = useState([]);

  const initialFilterObj = {
    dateFrom: moment().startOf("month").toDate(), // or your default
    dateTo: moment().toDate(),
    status: "All", // "ALL" | "ENTER" | "APPROVED"...
    transLoc: locationArr?.length > 0 ? locationArr.map((loc) => loc.Uid) : "",
    PromoStatus: "ALL",
  };
  const [filterObj, setFilterObj] = useState(initialFilterObj);

  const handleDelete = (row) => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to delete this promotion?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const payload = {
                TransId: row.TransId, 
                UserCd: vRdxUserCd?.UserID, 
              };

              const res = await PAP_Head_Userwise_DeleteApi(payload);

              if (res?.status === 200) {
                fAlertToast("SUCCESS", "Deleted successfully");
                fLoad(); 
              }
            } catch (err) {}
          },
        },
        { label: "No" },
      ],
    });
  };

  const statusColor = (s) =>
    /post/i.test(s) ? "success" : /enter/i.test(s) ? "info" : "default";

  const columns = [
    {
      key: "TransId",
      header: "ID",
      width: 25,
      sortable: true,
      filterable: true,
      align: "center",
    },
    {
      key: "TransDt",
      header: "Date",
      sortable: false,
      filterable: false,
      align: "center",
      render: (r) => (
        <Typography>
          {r.TransDt ? moment(r.TransDt).format("DD/MM/YYYY") : ""}
        </Typography>
      ),
    },
    {
      key: "TransLocName",
      header: "Location",
      sortable: true,
      filterable: true,
      align: "left",
      width: 90,
      render: (r) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <LocationOnIcon
            sx={{
              color: (theme) => theme.palette["custom-grid-info"].main,
              fontSize: 18,
            }}
          />
          <Typography>{r.TransLocName}</Typography>
        </Stack>
      ),
    },
    {
      key: "PromoLocName",
      header: "Promo Locations",
      sortable: true,
      filterable: true,
      align: "left",
      width: 200,
    },

    {
      key: "PromoTitle",
      header: "Title",
      sortable: true,
      filterable: true,
      align: "left",
      width: 140,
      render: (r) => (
        <Typography
          sx={{
            color: (theme) => theme.palette["custom-grid-primary"].main,
            fontWeight: 600,
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          {r.PromoTitle}
        </Typography>
      ),
    },
    {
      key: "PromoTyp",
      header: "Type",
      sortable: true,
      filterable: true,
      align: "left",
      width: 35,
    },

    {
      key: "Pages",
      header: "Pages",
      sortable: true,
      filterable: true,
      align: "left",
      width: 35,
      render: (r) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={"left"}
          spacing={1}
        >
          {r.Pages !== "" && (
            <>
              {" "}
              <DescriptionIcon
                sx={{
                  color: (theme) => theme.palette["custom-grid-secondary"].main,
                  fontSize: 18,
                }}
              />
              <Typography>{r.Pages}</Typography>
            </>
          )}
        </Stack>
      ),
    },

    {
      key: "BookletSizeName",
      header: "Size",
      sortable: true,
      filterable: true,
      align: "left",
      width: 30,
      render: (r) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={"left"}
          spacing={1}
        >
          <ViewCompactIcon
            sx={{
              color: (theme) => theme.palette["custom-grid-success"].main,
              fontSize: 18,
            }}
          />
          <Typography>{r.BookletSizeName}</Typography>
        </Stack>
      ),
    },
    {
      key: "PDF_URL",
      header: "Pdf Url",
      sortable: false,
      filterable: false,
      align: "left",
      width: 250,
      render: (r) => (
        <Typography>{r.PDF_URL ? r.PDF_URL : "No PDF"}</Typography>
      ),
    },
    {
      key: "FromDt",
      header: "From",
      sortable: false,
      filterable: false,
      align: "center",
      render: (r) => (
        <Typography>
          {r.FromDt ? moment(r.FromDt).format("DD/MM/YYYY") : ""}
        </Typography>
      ),
    },
    {
      key: "ToDt",
      header: "To",
      sortable: false,
      filterable: false,
      align: "center",
      render: (r) => (
        <Typography>
          {r.ToDt ? moment(r.ToDt).format("DD/MM/YYYY") : ""}
        </Typography>
      ),
    },
    ...[
      { k: "ProofRead_Status", h: "Proof Read" },
      { k: "Print_Status", h: "Print" },
      { k: "Recieved_Status", h: "Recieved" },
      { k: "Distri_Status", h: "Distribution" },
      { k: "CN_Status", h: "Credit Note" },
    ].map(({ k, h }) => ({
      key: k,
      header: h,
      sortable: true,
      filterable: true,
      align: "center",
      render: (r) => (
        <Chip
          label={r[k]}
          size="small"
          color={statusColor(r[k])}
          variant="standard"
        />
      ),
    })),
    {
      key: "EnByName",
      header: "Entered By",
      sortable: true,
      filterable: true,
      align: "left",
      width: 80,
    },
    {
      key: "EnDt",
      header: "Entered On",
      sortable: false,
      filterable: false,
      align: "center",
      width: 80,
      render: (r) => (
        <Typography>
          {r.EnDt ? moment(r.EnDt).format("DD/MM/YYYY") : ""}
        </Typography>
      ),
    },
    {
      key: "Delete",
      header: "Delete",
      width: 40,
      align: "center",
      sortable: false,
      filterable: false,
      render: (r) => (
        <Tooltip title="Delete">
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.stopPropagation(); // 🚫 prevent row click
              handleDelete(r);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const typMap = {
    Initialize: "",
    Category: "CS",
    Items: "IS",
    ItemsVerify: "IV",
    Design: "D",
    ProofReading: "PR",
    Print: "P",
    Received: "RP",
    Distribution: "DP",
  };

  const fRowClick = (row) => {
    if (pageType === "Initialize") {
      setPromoCreationDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Category") {
      setCategoryDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Items" || pageType === "ItemsVerify") {
      setItemSelectionDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Design" || pageType === "ProofReading") {
      setDesignDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Print") {
      setSendDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Received" || pageType === "Distribution") {
      setReceivedDrawer(true);
      setSelectedPromo(row);
    } else if (pageType === "Analysis") {
      setAnalysis(true);
      setSelectedPromo(row);
    }
  };

  // -------- API loader using your format
  const fLoad = async () => {
    try {
      const response = await QuickSale_PAP_Head_Summary({
        fromDt: moment(filterObj.dateFrom).format("MM/DD/YYYY"),
        toDt: moment(filterObj.dateTo).format("MM/DD/YYYY"),
        transLoc: Array.isArray(filterObj.transLoc)
          ? filterObj.transLoc.toString()
          : "",
        status: filterObj.status,
        userCd: vRdxUserCd?.UserID,
        typ:
          pageType === "Print"
            ? "P"
            : pageType === "Received"
            ? "RP"
            : pageType === "Distribution"
            ? "DP"
            : pageType === "Analysis"
            ? "DP"
            : "PR",
        Status2:filterObj?.PromoStatus,
      });
      if (response.status === 200) setRows(response?.data?.recordset ?? []);
    } catch (err) {
      fAlertToast("FAILED", err?.response?.data?.error || err?.message);
    }
  };

  const fGetBookletSize = async () => {
    const result = await PackingUnit_Buyer_getrowsAPI();
    if (result?.status === 200) {
      const data = result?.data?.BookletSize ?? [];
      setBookletSizes(data);
    }
  };

  const handleNew = () => {
    setSelectedPromo({
      TransId: 0,
      PromoTitle: "",
      TransDt: moment().toDate(),
      TransLoc: locationArr?.length > 0 ? locationArr[0]?.Uid : "",
      PromoLoc: "",
      FromDt: moment().startOf("month").toDate(),
      ToDt: moment().toDate(),
      PromoTyp: "Flyer",
      Pages: 0,
      BookletSize: bookletSizes?.[0]?.UID ?? "", // ✅ always defined
    });
    setPromoCreationDrawer(true);
  };

  useEffect(() => {
    const init = async () => {
      await fLoad(); // then load data
    };
    init();
  }, [pageType]);

  useEffect(() => {
    const selectedPromoObj = rows?.find(
      (r) => r.TransId === selectedPromo?.TransId
    );
    setSelectedPromo((prev) => ({
      ...prev,
      ...selectedPromoObj,
      CompletionPerc: selectedPromoObj?.CompletionPerc,
    }));
  }, [rows]);

  useEffect(() => {
    const init = async () => {
      await fGetBookletSize();
    };
    init();
  }, []);

  return (
    <>
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Breadcrumbs pageType={pageType} />
        {/* filters */}
        <Grid
          container
          spacing={{ xs: 1.5, md: 1 }}
          sx={{ alignItems: { xs: "flex-end" }, my: { xs: 1, sm: 1.5 } }}
        >
          <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <CmpDatePickerField001V1
              xLabelText="From Date"
              xName={"dateFrom"}
              xValue={filterObj?.dateFrom}
              xOnChange={(newValue) => {
                setFilterObj((prev) => ({
                  ...prev,
                  dateFrom: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <CmpDatePickerField001V1
              xLabelText="To Date"
              xName={"dateTo"}
              xValue={filterObj?.dateTo}
              xOnChange={(newValue) => {
                setFilterObj((prev) => ({
                  ...prev,
                  dateTo: newValue?.$d ?? newValue,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4.5} lg={4}>
            <GCAutocompleteCheckboxFixSizeUid
              options={locationArr ?? []} // ✅ Pass location list
              label="Locations" // ✅ Correct prop name
              xValue={filterObj?.transLoc} // ✅ Correct prop name
              setValue={(
                newValue // ✅ Will update filterObj
              ) => setFilterObj((prev) => ({ ...prev, transLoc: newValue }))}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                size="small"
                label={"Status"}
                value={filterObj?.status}
                name="status"
                onChange={(e) => {
                  setFilterObj((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }));
                }}
              >
                {statusOptions?.map((obj) => (
                  <MenuItem className="menuSm" key={obj} value={obj}>
                    {obj}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
            <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
            <FormControl fullWidth>
              <InputLabel>Promotion Status</InputLabel>
              <Select
                size="small"
                label={"Status"}
                value={filterObj?.PromoStatus}
                name="PromoStatus"
                onChange={(e) => {
                  setFilterObj((prev) => ({
                    ...prev,
                    PromoStatus: e.target.value,
                  }));
                }}
              >
                {PromoStatus?.map((obj) => (
                  <MenuItem className="menuSm" key={obj} value={obj}>
                    {obj}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={9.5}
            lg={1.9}
            container
            justifyContent="flex-end"
          >
            <Box display="flex" flexWrap="wrap" gap={1}>
              <Button
                variant="contained"
                size="small"
                color="success"
                onClick={() => fLoad()}
              >
                Load
              </Button>
              {pageType === "Initialize" && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleNew} // ✅ open for new
                >
                  New
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
        <CustomDatagrid
          pageType={pageType}
          columns={columns}
          rows={rows}
          dense={true}
          showFilters={true}
          initialPageSize={10}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          onRowClick={(r) => fRowClick(r)}
          onSelectionChange={(ids, selectedRows) =>
            console.log(ids, selectedRows)
          }
          height={{
            xs: showPagination ? "37.5vh" : "50vh",
            sm: showPagination ? "49vh" : "58vh",
            md: showPagination ? "51vh" : "60vh",
            lg: showPagination ? "55.5vh" : "65vh",
            xl: showPagination ? "58vh" : "68vh",
          }}
        />
      </Box>
      <PromotionCreationSidenav
        open={promoCreationDrawer}
        onClose={() => setPromoCreationDrawer(false)}
        selectedPromo={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        locations={locationArr}
        loadSummary={fLoad}
        userCd={vRdxUserCd?.UserID}
        bookletSizes={bookletSizes}
        locationArr={locationArr}
      />
      <CategorySelectionSideNav
        open={categoryDrawer}
        onClose={() => setCategoryDrawer(false)}
        selectedPromo={selectedPromo}
        baseURL={baseURL}
        pageType={pageType}
        loadSummary={fLoad}
        userCd={vRdxUserCd?.UserID}
      />
      <DesignDrawer
        open={designDrawer}
        onClose={() => setDesignDrawer(false)}
        selectedPromo={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        UserId={vRdxUserCd?.UserID}
        pageType={pageType}
        loadSummary={fLoad}
      />
      <ItemSelectionSideNav
        open={itemSelectionDrawer}
        onClose={() => setItemSelectionDrawer(false)}
        data={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        pageType={pageType}
        loadSummary={fLoad}
        userCd={vRdxUserCd?.UserID}
      />

      <SendPrintingSideNav
        open={sendDrawer}
        onClose={() => setSendDrawer(false)}
        selectedPromo={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        userCd={vRdxUserCd?.UserID}
        fLoad={fLoad}
      />

      <ReceivedFromPrintingSideNav
        open={receivedDrawer}
        onClose={() => setReceivedDrawer(false)}
        selectedPromo={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        pageType={typMap[pageType] ?? ""}
        userCd={vRdxUserCd?.UserID}
        Summary={fLoad}
        pageTyp={pageType}
      />
      <AnalysisReport
        open={analysis}
        onClose={() => setAnalysis(false)}
        selectedPromo={selectedPromo}
        setSelectedPromo={setSelectedPromo}
        userCd={vRdxUserCd?.UserID}
        Summary={fLoad}
        pageTyp={pageType}
      />
    </>
  );
}
